import React from 'react';
import { Box } from '@material-ui/core';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FDContentContainer } from '@facet-wealth/design';
import UpNextTasking from './UpNextTaskingPicker';

const styles = (theme => ({
  root: {
    backgroundColor: theme.palette.facet.lightGray,
  },
}));

const UpNextTaskingDesktop = ({
  classes,
  className,
}) => {
  return (
    <Box className={classNames(classes.root, className)}>
      <FDContentContainer maxWidth="xl">
        <UpNextTasking />
      </FDContentContainer>
    </Box>
  );
};

UpNextTaskingDesktop.defaultProps = {
  className: '',
};

UpNextTaskingDesktop.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(UpNextTaskingDesktop);
